import React, { Component } from 'react'

import PropTypes from 'prop-types'

import moment from 'moment'

import getByPath from 'lodash/get'
import isFunction from 'lodash/isFunction'
import { Draggable } from 'react-beautiful-dnd'
import config from '../../config'

import MaterialTimePicker from 'material-ui/TimePicker'

export default class NoteActivity extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    onEditClick: PropTypes.func,
    onClick: PropTypes.func,
    onRemove: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      newTime: moment(),
      isTimeEditing: false
    }
  }

  render() {
    const { data, type, onClick, onRemove, onEditClick } = this.props
    let photo = data.note.defaultPhoto ? data.note.defaultPhoto : null

    return (
      <Draggable draggableId={data.note.id}>
        {(provided, snapshot) => (
          <div {...provided.dragHandleProps} ref={provided.innerRef} style={{ ...provided.draggableStyle }}>
            <div className="trip__plan-part plan-part">
              <hr />

              <div className="plan-part__title flex">
                <span>{data.title}&nbsp;</span>
                <div className="flex">
                  <span className="plan-part__action" onClick={() => onEditClick(data.note)}>
                    <i className="icon-edit" />
                  </span>
                  <span className="plan-part__action" onClick={() => onRemove(data.note.id)}>
                    <i className="icon-delete" />
                  </span>
                </div>
              </div>
              <div className="plan-part__search-result search-result">
                <img
                  src={photo ? photo.s3Url : 'http://via.placeholder.com/150x90'}
                  className="search-result__photo"
                  alt=""
                />
                <div className="search-result__title">{data.note.description}</div>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    )
  }
}



// WEBPACK FOOTER //
// src/components/Notes/NoteActivity.js